<div class="connexion">
    <form class="connexion__form" (ngSubmit)="login()">
        <img alt="" src="/assets/img/pv/logo-pv.png" *ngIf="brand === 'pv'" />
        <h1>{{ type === "travel" ? "Envie de voyager " : "Futurs mariés " }}?</h1>
        <div class="connexion__form__input">
            <div class="input-connection">
                <label for="id_email">Email ou Identifiant</label>
                <div class="input__wrapper">
                    <span class="mv-icons--simple--users"></span>
                    <input
                        type="email"
                        id="id_email"
                        name="idMail"
                        placeholder="Votre email ou identifiant"
                        [(ngModel)]="idMail"
                        autofocus
                    />
                </div>
            </div>
            <div class="input-connection">
                <label for="password">Mot de passe</label>
                <div class="input__wrapper">
                    <span class="mv-icons--simple--preview"></span>
                    <input
                        id="password"
                        type="password"
                        name="idPassword"
                        placeholder="Mot de passe"
                        [(ngModel)]="idPassword"
                    />
                </div>
            </div>
            <div class="error" *ngIf="errorConnexion" innerHTML="{{ messageError }}"></div>
            <a routerLink="/mot-de-passe-oublie">Mot de passe perdu ?</a>
        </div>

        <div class="connexion__form__action">
            <mv-button
                [color]="brand == 'mv' ? 'raspberry' : 'primary'"
                label="CONNEXION"
                type="submit"
                (click)="login()"
                ><button></button>
            </mv-button>
            <a class="link-style2" (click)="showPopupSearch()">Vous recherchez une liste ?</a>
            <div class="separator">ou</div>
            <a class="link-style2" routerLink="/inscription">Vous n’êtes pas encore inscrits ?</a>
        </div>
    </form>
</div>
